import { render, staticRenderFns } from "./ModalEditParticipant.vue?vue&type=template&id=ffc79352&scoped=true&"
import script from "./ModalEditParticipant.vue?vue&type=script&lang=js&"
export * from "./ModalEditParticipant.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditParticipant.vue?vue&type=style&index=0&id=ffc79352&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc79352",
  null
  
)

export default component.exports